<template>
  <section class="shopping-finish">
    <div class="container">
      <Progress :step.sync="step" />

      <div class="shopping-finish__content">
        <div v-if="step === 4" class="shopping-finish__success">
          <div class="shopping-finish__icon">
            <i class="el-icon-circle-check"></i>
          </div>
          <h2 class="shopping-finish__title">{{ $t('shopping.finish.orderComplete') }}</h2>
        </div>

        <div v-if="step === 3" class="shopping-finish__error">
          <div class="shopping-finish__icon shopping-finish__icon--error">
            <i class="el-icon-circle-close"></i>
          </div>
          <h2 class="shopping-finish__title">{{ $t('shopping.finish.orderFailed') }}</h2>
        </div>

        <div v-if="payMethodes" class="shopping-finish__payment-info">
          <h3 class="shopping-finish__subtitle">{{ $t('shopping.label.paymentInfo') }}</h3>
          <div class="shopping-finish__info-card">
            <div class="shopping-finish__info-row">
              <span class="shopping-finish__label">{{ $t('shopping.label.paymentCode') }}</span>
              <span class="shopping-finish__value">{{ Super.paymentNo }}</span>
            </div>
            <div class="shopping-finish__info-row">
              <span class="shopping-finish__label">{{ $t('shopping.label.paymentDeadline') }}</span>
              <span class="shopping-finish__value">
                {{ Super.expireDate | toTaipei | moment('YYYY-MM-DD HH:mm:ss') }}
              </span>
            </div>

            <template v-if="Super.bankCode">
              <div class="shopping-finish__atm-info">
                <div class="shopping-finish__info-row">
                  <span class="shopping-finish__label">{{ $t('shopping.finish.bankCode') }}</span>
                  <span class="shopping-finish__value">{{ Super.bankCode }}</span>
                </div>
                <div class="shopping-finish__info-row">
                  <span class="shopping-finish__label">{{ $t('shopping.finish.virtualAccount') }}</span>
                  <span class="shopping-finish__value">{{ Super.vAccount }}</span>
                </div>
                <div class="shopping-finish__info-row">
                  <span class="shopping-finish__label">
                    {{ $t('shopping.finish.expireDate') }}
                  </span>
                  <span class="shopping-finish__value">
                    {{ Super.expireDate | toTaipei | moment('YYYY-MM-DD HH:mm:ss') }}
                  </span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <div class="shopping-finish__actions">
        <router-link
          class="shopping-finish__button"
          to="/member/orders"
        >
          <i class="el-icon-document"></i>
          {{ $t('shopping.finish.viewOrder') }}
        </router-link>
      </div>
    </div>
  </section>
</template>

<script>
import Progress from '@/components/Shopping/Progress.vue';
import { GetEcPayPaymentInfo } from '@/api/ShoppingCartApi';

export default {
  components: {
    Progress,
  },
  data() {
    return {
      step: 4,
      noteStr: '',
      Super: {
        // paymentNo: '',
        // expireDate: '',
      },
      payMethodes: false,
    };
  },
  created() {
    this.noteStr = this.$t('shopping.finish.orderComplete');
    const { step } = this.$route.params;
    const { Qcode, t } = this.$route.query;
    if (step === undefined && Qcode === undefined && t === undefined) this.$router.replace('/');
    this.step = step;
    if (step === 3) this.noteStr = this.$t('shopping.finish.orderFailed');
    if (Qcode !== undefined) {
      this.step = 4;
      this.GetEcPayPaymentInfo(Qcode);
    }
    if (t !== undefined) this.step = 4;
  },
  methods: {
    GetEcPayPaymentInfo(Qcode) {
      GetEcPayPaymentInfo(Qcode).then((response) => {
        if (response.data.statusCode === 0) {
          this.Super = response.data.data;
          this.payMethodes = true;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';
.shopping-finish {
  &__content {
    background-color: var(--background-white);
    border-radius: var(--border-radius-lg);
    border: 1px solid var(--border-lighter);
    padding: 48px 32px;
    margin: 32px 0;

    @media (max-width: $breakpoint-sm) {
      padding: 32px 20px;
    }
  }

  &__success,
  &__error {
    text-align: center;
    margin-bottom: 32px;
  }

  &__icon {
    width: 100px;
    height: 100px;
    margin: 0 auto 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(103, 194, 58, 0.1);
    border-radius: 50%;

    i {
      font-size: 60px;
      color: var(--success-color);
    }

    &--error {
      background-color: rgba(245, 108, 108, 0.1);

      i {
        color: var(--danger-color);
      }
    }
  }

  &__title {
    font-size: var(--font-size-xl);
    font-weight: 700;
    color: var(--text-primary);
    margin: 0 0 16px 0;
  }

  &__message {
    font-size: var(--font-size-base);
    color: var(--text-regular);
    margin: 0;
  }

  &__subtitle {
    font-size: var(--font-size-lg);
    font-weight: 600;
    color: var(--text-primary);
    margin: 0 0 20px 0;
    padding-bottom: 12px;
    border-bottom: 2px solid var(--border-lighter);
  }

  &__payment-info {
    margin-top: 32px;
  }

  &__info-card {
    background-color: var(--background-light);
    border-radius: var(--border-radius-base);
    padding: 24px;
  }

  &__info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid var(--border-lighter);

    &:last-child {
      border-bottom: none;
    }

    @media (max-width: $breakpoint-xs) {
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
    }
  }

  &__label {
    font-size: var(--font-size-sm);
    color: var(--text-secondary);
    font-weight: 600;
  }

  &__value {
    font-size: var(--font-size-base);
    color: var(--text-primary);
    font-weight: 500;
    word-break: break-all;
  }

  &__atm-info {
    margin-top: 20px;
    padding-top: 20px;
    border-top: 2px solid var(--primary-light-color);
  }

  &__actions {
    display: flex;
    justify-content: center;
    margin-top: 32px;
  }

  &__button {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 14px 48px;
    font-size: var(--font-size-base);
    font-weight: 600;
    color: var(--text-white);
    background-color: var(--primary-color);
    border: none;
    border-radius: var(--border-radius-base);
    text-decoration: none;
    cursor: pointer;
    transition: all var(--transition-base);

    i {
      font-size: 18px;
    }

    &:hover {
      background-color: #0099d8;
      transform: translateY(-2px);
    }

    @media (max-width: $breakpoint-sm) {
      width: 100%;
      justify-content: center;
      padding: 12px 32px;
    }
  }
}
</style>
